/* import __COLOCATED_TEMPLATE__ from './checkbox-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();